import React from 'react';
import { Dialog, DialogContent, Box, Typography, Button, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import { useT } from '../i18n/LanguageContext';

const getSteps = (t) => [
  { n: '1', t: t('canvas.coachmarks.step1Title'), d: t('canvas.coachmarks.step1Body') },
  { n: '2', t: t('canvas.coachmarks.step2Title'), d: t('canvas.coachmarks.step2Body') },
  { n: '3', t: t('canvas.coachmarks.step3Title'), d: t('canvas.coachmarks.step3Body') },
];

// First-run welcome / 3-step coachmarks for the canvas.
export default function CanvasCoachmarks({ open, onClose, onPickTemplate }) {
  const theme = useTheme();
  const t = useT();
  const cyan = theme.home?.cyan || '#1FB6E8';
  const ink = theme.home?.ink || '#14181D';
  const inkHover = theme.home?.inkHover || '#000000';
  const display = theme.home?.display || 'Georgia, serif';
  const steps = getSteps(t);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: { xs: 3, md: 4.5 }, textAlign: 'center' }}>
        <AutoAwesomeIcon sx={{ color: cyan, fontSize: 44, mb: 1 }} />
        <Typography sx={{ fontFamily: display, fontWeight: 800, fontSize: '1.7rem', color: ink }}>
          {t('canvas.coachmarks.heading')}
        </Typography>
        <Typography sx={{ color: 'text.secondary', mt: 1, mb: 3 }}>
          {t('canvas.coachmarks.body')}
        </Typography>

        <Stack spacing={2} sx={{ textAlign: 'left', mb: 3.5 }}>
          {steps.map((s) => (
            <Box key={s.n} sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
              <Box sx={{
                flexShrink: 0, width: 30, height: 30, borderRadius: '50%', bgcolor: cyan, color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontFamily: display,
              }}>{s.n}</Box>
              <Box>
                <Typography sx={{ fontWeight: 700, color: ink }}>{s.t}</Typography>
                <Typography sx={{ color: 'text.secondary', fontSize: '0.9rem' }}>{s.d}</Typography>
              </Box>
            </Box>
          ))}
        </Stack>

        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.5} justifyContent="center">
          <Button variant="contained" onClick={onPickTemplate}
            sx={{ borderRadius: 999, px: 3, py: 1.2, bgcolor: ink, '&:hover': { bgcolor: inkHover } }}>
            {t('canvas.coachmarks.ctaTemplate')}
          </Button>
          <Button variant="text" onClick={onClose} sx={{ borderRadius: 999, color: ink }}>
            {t('canvas.coachmarks.ctaFree')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
